import { render, staticRenderFns } from "./SingleFileHolder.vue?vue&type=template&id=b888784e&scoped=true&"
import script from "./SingleFileHolder.vue?vue&type=script&lang=ts&"
export * from "./SingleFileHolder.vue?vue&type=script&lang=ts&"
import style0 from "./SingleFileHolder.vue?vue&type=style&index=0&id=b888784e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b888784e",
  null
  
)

export default component.exports